const getScopes = () => {
  return process.env.REACT_APP_SCOPE || 'startplus_dev';
};

export default getScopes;
